<template>
  <div class="position_relative">
    <div class="padding_content" id="padding_url">
      <div id="malware_container">
        <Search :serviceName="serviceName"></Search>
        <div v-if="product.urlFiltering">
          <h3 class="choose">{{ $t('service.choose') }}</h3>
          <div
            class="better_suits"
            v-if="product.urlFiltering.apiPlans && product.urlFiltering.apiPlans.length > 0"
          >
            <p>{{ $t('service.apiLevel') }}</p>
            <div class="product_list">
              <div
                class="product_li"
                v-for="(item, index) in product.urlFiltering.apiPlans"
                :key="index"
              >
                <img
                  :src="lang === 'en' ? recommendedImg1 : recommendedImg2"
                  alt=""
                  v-if="item.tag == 'recommended'"
                  class="recommended"
                />
                <img
                  :src="lang === 'en' ? subscribedImg1 : subscribedImg2"
                  alt=""
                  v-if="item.tag == 'subscribed'"
                  class="recommended"
                />
                <div v-if="item.discountPrice">
                  <h3 class="new_price"><span>$</span>{{ item.discountPrice }}</h3>
                  <h3 class="old_price"><span>$</span>{{ item.originalPrice }}</h3>
                </div>
                <h3 class="new_price" v-if="!item.discountPrice">
                  <span>$</span>{{ item.originalPrice }}
                </h3>
                <p class="way">
                  {{ lang === 'en' ? item.type : formatTypes(item.type) || item.type }}
                </p>
                <div v-if="lang === 'en' && item.description.en">
                  <div class="description">
                    <p v-for="(ditem, dindex) in item.description.en" :key="dindex">{{ ditem }}</p>
                  </div>
                  <div
                    class="select_btn"
                    @click="
                      jump(
                        'URL Filtering Service',
                        item.planId,
                        item.discountPrice,
                        item.originalPrice,
                        item.type,
                        item.description.en
                      )
                    "
                    v-if="item.tag !== 'subscribed'"
                  >
                    {{ $t('service.select') }}
                  </div>
                  <div class="select_btn subscribe_btn" v-if="item.tag == 'subscribed'">
                    <el-button type="text" @click="open(item.subId)">{{
                      $t('service.unsubscribe')
                    }}</el-button>
                  </div>
                </div>
                <div v-if="lang === 'zh' && item.description.zh">
                  <div class="description">
                    <p v-for="(ditem, dindex) in item.description.zh" :key="dindex">{{ ditem }}</p>
                  </div>
                  <div
                    class="select_btn"
                    @click="
                      jump(
                        'URL Filtering Service',
                        item.planId,
                        item.discountPrice,
                        item.originalPrice,
                        item.type,
                        item.description.zh
                      )
                    "
                    v-if="item.tag !== 'subscribed'"
                  >
                    {{ $t('service.select') }}
                  </div>
                  <div class="select_btn subscribe_btn" v-if="item.tag == 'subscribed'">
                    <el-button type="text" @click="open(item.subId)">{{
                      $t('service.unsubscribe')
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="better_suits malware_list"
            v-if="
              product.urlFiltering.maliciousUrlListPlans &&
                product.urlFiltering.maliciousUrlListPlans.length > 0
            "
          >
            <p class="malware_title">{{ $t('service.urlLevel') }}</p>
            <div class="product_list">
              <div
                class="product_li"
                v-for="(item, index) in product.urlFiltering.maliciousUrlListPlans"
                :key="index"
              >
                <img
                  :src="lang === 'en' ? recommendedImg1 : recommendedImg2"
                  alt=""
                  v-if="item.tag == 'recommended'"
                  class="recommended"
                />
                <img
                  :src="lang === 'en' ? subscribedImg1 : subscribedImg2"
                  alt=""
                  v-if="item.tag == 'subscribed'"
                  class="recommended"
                />
                <div v-if="item.discountPrice">
                  <h3 class="new_price"><span>$</span>{{ item.discountPrice }}</h3>
                  <h3 class="old_price"><span>$</span>{{ item.originalPrice }}</h3>
                </div>
                <h3 class="new_price" v-if="!item.discountPrice">
                  <span>$</span>{{ item.originalPrice }}
                </h3>
                <p class="way">
                  {{ lang === 'en' ? item.type : formatTypes(item.type) || item.type }}
                </p>
                <div v-if="lang === 'en' && item.description.en">
                  <div class="description">
                    <p v-for="(ditem, dindex) in item.description.en" :key="dindex">{{ ditem }}</p>
                  </div>
                  <div
                    class="select_btn"
                    @click="
                      jump(
                        'URL Filtering Service',
                        item.planId,
                        item.discountPrice,
                        item.originalPrice,
                        item.type,
                        item.description.en
                      )
                    "
                    v-if="item.tag !== 'subscribed'"
                  >
                    {{ $t('service.select') }}
                  </div>
                  <div class="select_btn subscribe_btn" v-if="item.tag == 'subscribed'">
                    <el-button type="text" @click="open(item.subId)">{{
                      $t('service.unsubscribe')
                    }}</el-button>
                  </div>
                </div>
                <div v-if="lang === 'zh' && item.description.zh">
                  <div class="description">
                    <p v-for="(ditem, dindex) in item.description.zh" :key="dindex">{{ ditem }}</p>
                  </div>
                  <div
                    class="select_btn"
                    @click="
                      jump(
                        'URL Filtering Service',
                        item.planId,
                        item.discountPrice,
                        item.originalPrice,
                        item.type,
                        item.description.zh
                      )
                    "
                    v-if="item.tag !== 'subscribed'"
                  >
                    {{ $t('service.select') }}
                  </div>
                  <div class="select_btn subscribe_btn" v-if="item.tag == 'subscribed'">
                    <el-button type="text" @click="open(item.subId)">{{
                      $t('service.unsubscribe')
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <serviceFooter @scale="scale" :service="service"></serviceFooter>
    <loading :show="loading"></loading>
  </div>
</template>

<script>
import Search from './search'
import serviceFooter from './footer'
import loading from '../../components/loading'
import axios from 'axios'
import { Message } from 'element-ui'
import { common } from '../public/common'
import { downAPP } from '../public/validator'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'URLFiltering',
  components: { Search, serviceFooter, loading, common },
  data() {
    return {
      product: {},
      loading: true,
      service: 'url',
      // serviceName: 'URL Filtering Service',
      recommendedImg1: require('../../assets/img/mark-recommended.png'),
      recommendedImg2: require('../../assets/img/recommended-zh.png'),
      subscribedImg1: require('../../assets/img/mark-subscribed.png'),
      subscribedImg2: require('../../assets/img/subscribed-zh.png')
    }
  },
  methods: {
    getServiceData: function() {
      let self = this
      axios
        .get('/api/product')
        .then(response => {
          self.$set(this, 'product', response.data)
          self.loading = false
        })
        .catch(err => {
          Message({
            type: 'error',
            message: err.response.data.statusCode + ' ' + err.response.data.message,
            showClose: true
          })
          self.loading = false
        })
    },
    jump(service, planId, discountPrice, originalPrice, type, description) {
      let query = {
        service: service,
        planId: planId,
        discountPrice: discountPrice,
        originalPrice: originalPrice,
        type: type,
        description: description
      }
      this.$router.push({ path: '/payment', query: query }).catch(err => {
        // to hide the below error message
        if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
          throw Error(err)
        }
      })
    },
    open(subId) {
      this.$confirm(this.$t('message.urlUnsubscribe'), this.$t('message.confirm'), {
        confirmButtonText: this.$t('message.UNSUBSCRIBE'),
        cancelButtonText: this.$t('message.CANCEL'),
        customClass: 'modal_messageBox'
      })
        .then(() => {
          this.changeUnsubscribe(subId)
        })
        .catch(() => {})
    },
    changeUnsubscribe(subId) {
      let data = {
        subId: subId
      }
      axios
        .post('/api/unsubscribe', data)
        .then(res => {
          Message({
            type: 'success',
            message: 'Unsubscribed successfully',
            showClose: true
          })
          this.getServiceData()
        })
        .catch(err => {
          Message({
            type: 'error',
            message: err.response.data.statusCode + ' ' + err.response.data.message,
            showClose: true
          })
        })
    },
    scale(val) {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      if (val) {
        document.getElementById('padding_url').style.paddingBottom = '200px'
      } else {
        document.getElementById('padding_url').style.paddingBottom = '83px'
      }
      if (val && document.documentElement.clientWidth < 450 && isiOS) {
        document.getElementById('padding_url').style.paddingBottom = '300px'
      }
      if (!val && document.documentElement.clientWidth < 450 && isiOS) {
        document.getElementById('padding_url').style.paddingBottom = '180px'
      }
    },
    formatTypes: common.formatTypes
  },
  computed: {
    serviceName() {
      return this.$t('service.urlService')
    },
    lang() {
      return this.$store.state.lang
    }
  },
  mounted() {
    this.getServiceData()
    downAPP('padding_url', '180px')
  }
}
</script>

<style lang="scss" src="./service.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/service/url.vue